import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, input, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IonIcon, IonRippleEffect } from "@ionic/angular/standalone";
import { addIcons } from 'ionicons';
import { chevronForward, settingsOutline, helpBuoyOutline, phonePortraitSharp, fingerPrintOutline } from 'ionicons/icons';

@Component({
    selector: 'app-row',
    templateUrl: './row.component.html',
    styleUrls: ['./row.component.scss'],
    imports: [IonRippleEffect, IonIcon, CommonModule]
})
export class RowComponent {

  public label = input.required<string>();
  public border = input<boolean>(true);

  @Input() customAction: boolean = false;
  @Input() icon: string = "home-outline";
  @Input() custom: boolean = false;
  @Input() color: string = "dark";
  @Input() arrow: boolean = true;
  @Input() route: string = ""
  @Input() hasIcon: boolean = true;

  @Output() action = new EventEmitter<any>();

  constructor(private router: Router) {
    addIcons({ chevronForward, settingsOutline, helpBuoyOutline, phonePortraitSharp, fingerPrintOutline });
  }

  goTo() {
    if(this.route) {
      this.router.navigate([this.route]);
    } else {
      this.action.emit(true);
    }
  }

  iconSrc = computed(() => {
    return `assets/icons/${this.icon}.svg`;
  })

}